import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Thhandlewarning from '../entities/handlewarning'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface ThhandlewarningState extends ListState<Thhandlewarning>{
    editHandlewarnings:Thhandlewarning
    anlyseHandlewarning:Thhandlewarning
    seeHandlewarnings:Thhandlewarning
}
class ThhandlewarningModule extends ListModule<ThhandlewarningState,any,Thhandlewarning>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Thhandlewarning>(),
        loading:false        
    }
    actions={
        async getPage(context:ActionContext<ThhandlewarningState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThHandleWarning/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Thhandlewarning>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getPagedLast(context: ActionContext<ThhandlewarningState, any>, payload: any) {

            // context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/ThHandleWarning/GetPagedLast', { params: payload.data });
            // context.state.loading = false;
            let page = reponse.data.result as PageResult<Thhandlewarning>;
            //context.state.totalCount = page.totalCount;
            //context.state.list = page.items;
            return page.items;
        },
        async create(context:ActionContext<ThhandlewarningState,any>,payload:any){
            await Ajax.post('/api/services/app/ThHandleWarning/CreateOrUpdate',payload.data);
        },
        async uploadimg(context:ActionContext<ThhandlewarningState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<ThhandlewarningState,any>,payload:any){
            await Ajax.put('/api/services/app/ThHandleWarning/Update',payload.data);
        },
        async delete(context:ActionContext<ThhandlewarningState,any>,payload:any){
            await Ajax.delete('/api/services/app/ThHandleWarning/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<ThhandlewarningState,any>,payload:any){
            let reponse=await Ajax.get('​/api​/services​/app​/ThHandleWarning​/GetById?Id='+payload.id);
            return reponse.data.result as Thhandlewarning;
        },
        async GetAllwarningList(context:ActionContext<ThhandlewarningState,any>){
            let reponse=await Ajax.get('/api/services/app/ThHandleWarning/getAllwarningList');
            return reponse.data.result;
        },
        ///获取所有设备数量
        async getAllwarning(context:ActionContext<HandlewarningState,any>){
            let reponse=await Ajax.get('/api/services/app/ThHandleWarning/getAllwarning');
            return reponse.data.result;
        },
        async getPageByDate(context: ActionContext<ThhandlewarningState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/ThHandleWarning/GetPageByDate', { params: payload.data });
            let page = reponse.data.result as PageResult<Thhandlewarning>;
            //context.state.totalCount = page.totalCount;
            //context.state.list = page.items; 6aba6214f15918e1bc4225e3ea66df430b9fbce7
            return page.items;
        },
    };
    mutations={
        setCurrentPage(state:ThhandlewarningState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:ThhandlewarningState,pagesize:number){
            state.pageSize=pagesize;
        },
        analyse(state: ThhandlewarningState, handlewarning:Thhandlewarning) {
            state.anlyseHandlewarning = handlewarning;
        },
        edit(state:ThhandlewarningState,handlewarning:Thhandlewarning){
            
            state.editHandlewarnings=handlewarning;
            //console.log(state.editFloor);
        },
        see(state:ThhandlewarningState,handlewarning:Thhandlewarning){
            
            state.seeHandlewarnings=handlewarning;
            //console.log(state.editFloor);
        }
    }
}
const thhandlewarningModule=new ThhandlewarningModule();
export default thhandlewarningModule;